export const URLMaderas =
  "https://ariaservicesapi.weblex.click/api/v1/cdmaderas";

export const URLSegura =
  "https://ariaservicesapi.weblex.click/api/v1/segura";

export const isMaderasPath = (path = "") =>
  path.includes("cdmaderas") || path.includes("living");

export const URLAPI = (path) =>
  isMaderasPath(path) ? URLMaderas : URLSegura;
